import { generate } from '../../../core/js/utils/componentUtils';
import { dDom } from '../../../core/js/utils/renderUtils';
import { error } from '@core/js/utils/logger';

import { removeHash, getQueryParams } from '../../../core/js/utils/routerUtils';
import { makeRequest } from '../../../core/js/sagas/makeRequest';
import { getQuickshopRoute } from '../../../core/js/utils/apiRoutes';

import { defaultQuickshopOptions } from '../utils/defaultQuickshopOptions';
import { launchAsyncQuickshop } from '@product/js/utils/asyncLaunchers';

import { bindOnPopStateEvent } from '../../../core/js/utils/browserUtils';
import { closeModal } from '@core/js/utils/modalUtils';

import queryString from 'query-string';

import template from 'quickshop.j2';

export function firstRender(store) {
    const state = store.getState();
    const hashParams = getQueryParams(window.location.hash);

    const params = {
        slug: _.get(hashParams, 'quickshop-slug', ""),
        color: _.get(hashParams, 'quickshop-color', "")
    };

    const concatQueryString = queryString.stringify(params);

    if (params.slug) {
        const records = [];

        store.runSaga(makeRequest, getQuickshopRoute(state, params)).done.then((result) => {
            const product = result.product;
            product.product.queryParams = concatQueryString;

            records.push(product);

            launchAsyncQuickshop(store, defaultQuickshopOptions, {}, records, 0);
        })
        .catch(err => {
            this.closeAction(store);
            error(err);
        });
    }
}

export function afterCloseAction(store) {
    // Remove hash and push state on close
    removeHash();
}

export function attachEvents(store) {
    // Close modal on back-button
    bindOnPopStateEvent(this, function(e) {
        closeModal(this, e);
    });
}

export function init(store, overrides = {}) {
    const config = {
        attachEvents: attachEvents,
        name: 'modal.quickshop',
        renderType: dDom,
        template: template,
        firstRender: firstRender,
        afterCloseAction: afterCloseAction
    };
    return generate(config, store, overrides);
}
